/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RagAppLabSearchDto } from '../../models/rag-app-lab-search-dto';
import { RagSearchResultDto } from '../../models/rag-search-result-dto';

export interface RagControllerSearchAppLabs$Params {
      body: RagAppLabSearchDto
}

export function ragControllerSearchAppLabs(http: HttpClient, rootUrl: string, params: RagControllerSearchAppLabs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RagSearchResultDto>>> {
  const rb = new RequestBuilder(rootUrl, ragControllerSearchAppLabs.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RagSearchResultDto>>;
    })
  );
}

ragControllerSearchAppLabs.PATH = '/rag/appLabSearch';
